/* eslint-disable prettier/prettier */
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { setCustomerFilterData } from '../redux/slices/filter.slice'
import { initFlowbite } from 'flowbite'
import { Pagination } from 'components'
import AddNewCustomerModal from 'components/modal/add-new-customer'
import EditCustomerModal from 'components/modal/edit-customer-modal'
import { newCustomerEntriesService } from 'services'
import { formatPrice } from 'utils'
import { _object } from 'utils/interfaces'
import { routes } from 'utils/routes'
import { DeleteIcon, ViewIcon } from 'assets/svg'

const NewCustomers = () => {
  const dispatch = useDispatch()
  const [results, setResults] = useState<_object>({})
  const [loading, setLoading] = useState(false)
  const savedFilters = useSelector((state: _object) => state.filter.customerFilter)

  const [filters, setFilters] = useState(
    Object.keys(savedFilters || {}).length ? savedFilters : {
      q: '',
      page: 1,
      per_page: 25,
      sort: '-created_at',
      filters: { status: '' }
    }
  )
  const customerList = () => {
    setLoading(true)
    newCustomerEntriesService.getNewCustomers(filters).then((results: _object) => {
      setResults(results)
      setLoading(false)
    })
  }

  useEffect(() => {
    customerList()
  }, [filters])

  useEffect(() => {
    dispatch(setCustomerFilterData(filters))
  }, [filters])

  useEffect(() => {
    initFlowbite()
  })

  const deleteCustomer = (id: string) => {
    if (window.confirm('Are you sure you want to delete?')) {
      newCustomerEntriesService.deletNewCustomer(id).then(() => {
        customerList()
      })
    }
  }
  return (
    <>
      {' '}
      <div className="mb-4 flex items-center justify-between">
        <h1 className="text-2xl font-semibold">
          Customers{' '}
          {results?.pagination?.total_items && (
            <small>Total records: {results?.pagination?.total_items}</small>
          )}
        </h1>
      </div>
      <div className="mb-4 flex gap-4">
        <form>
          <div className="flex items-center gap-2">
            <input
              type="search"
              placeholder="Search keyword"
              className="w-60 rounded-md border px-3 py-2 text-sm outline-none focus:outline-none"
              value={filters.q || ''}
              onChange={(e) => {
                setFilters({ ...filters, q: e.target.value })
              }}
            />

            <div className="relative w-full">
              <select
                name="status"
                value={filters.filters?.status || ''}
                onChange={(e) =>
                  setFilters((prev: _object) => ({
                    ...prev,
                    filters: {
                      ...prev.filters,
                      status: e.target.value
                    }
                  }))
                }
                className="block w-full appearance-none rounded-md border bg-white px-3 py-2 pr-10 text-sm outline-none focus:outline-none"
              >
                <option value="">All status</option>
                {[
                  { key: 'Pending', value: 'pending' },
                  { key: 'Completed', value: 'completed' }
                ].map((item, i) => (
                  <option key={i} value={item.value}>
                    {item.key}
                  </option>
                ))}
              </select>

              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-500">
                <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </div>
            </div>

            <button
              type="button"
              className="px-3 py-1 text-sm font-medium whitespace-nowrap text-red-600 underline"
              onClick={() => {
                setFilters({ per_page: 25 })
              }}
            >
              Clear filters
            </button>
          </div>
        </form>
      </div>
      <div className="overflow-x-auto rounded-lg bg-white shadow">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-100">
            <tr className="text-left text-sm font-medium text-gray-900">
              <th className="px-4 py-3 font-semibold">#</th>
              <th className="px-4 py-3 font-semibold">Name</th>
              <th className="px-4 py-3 font-semibold">Legal Structure</th>
              <th className="px-4 py-3 font-semibold">Status</th>
              <th className="px-4 py-3 font-semibold">Business Phone</th>
              <th className="px-4 py-3 font-semibold">Expected Monthly Purchases</th>
              <th className="px-4 py-3 text-center font-semibold">Action</th>
            </tr>
          </thead>

          <tbody className="divide-y divide-gray-100 text-sm">
            {loading === false ? (
              results?.items?.length > 0 &&
              results?.items?.map((item: _object, i: number) => {
                return (
                  <>
                    <tr className="hover:bg-gray-50" key={i}>
                      <td className="px-4 py-3"> {(filters.page - 1) * filters.per_page + i + 1}</td>
                      <td className="px-4 py-3">
                        {item?.applicant_fullname === 'null null' ? '' : item?.applicant_fullname}
                      </td>
                      <td className="px-4 py-3">{item?.legal_structure}</td>
                      <td className="px-4 py-3">
                        {item?.status?.charAt(0).toUpperCase() + item?.status?.slice(1)}
                      </td>
                      <td className="px-4 py-3">{item?.business_phone}</td>
                      <td className="px-4 py-3">{formatPrice(item?.expected_monthly_purchases)}</td>
                      <td className="flex justify-center gap-2 px-4 py-3">
                        <Link to={`${routes.newCustomer}/${item.id}`} title="View customer info">
                          <ViewIcon className="h-[20px] w-[20px]" />
                        </Link>
                        <button
                          type="button"
                          onClick={() => deleteCustomer(item.id)}
                          title="Delete Brand"
                        >
                          <DeleteIcon className="h-[20px] w-[20px]" />
                        </button>
                      </td>
                    </tr>
                    <EditCustomerModal id={item.id} />
                  </>
                )
              })
            ) : (
              <tr className="animate-pulse">
                <td className="px-4 py-3">
                  <div className="h-4 w-6 rounded bg-gray-300"></div>
                </td>
                <td className="px-4 py-3">
                  <div className="h-4 w-32 rounded bg-gray-300"></div>
                </td>
                <td className="px-4 py-3">
                  <div className="h-4 w-12 rounded bg-gray-300"></div>
                </td>
                <td className="px-4 py-3">
                  <div className="h-4 w-8 rounded bg-gray-300"></div>
                </td>
                <td className="px-4 py-3">
                  <div className="h-4 w-24 rounded bg-gray-300"></div>
                </td>
                <td className="px-4 py-3">
                  <div className="h-4 w-24 rounded bg-gray-300"></div>
                </td>

                <td className="flex justify-center gap-2 px-4 py-3">
                  <div className="h-5 w-5 rounded-full bg-gray-300"></div>
                  <div className="h-5 w-5 rounded-full bg-gray-300"></div>
                </td>
              </tr>
            )}
            {results?.items?.length <= 0 &&
              <td colSpan={12} className="text-center py-6 text-gray-500">
                <p>No record found</p>
              </td>
            }
          </tbody>
        </table>
      </div>
      {results?.pagination?.total_pages > 1 && loading === false && (
        <Pagination
          pageCount={results?.pagination?.total_pages}
          current_page={results?.pagination?.current_page}
          onPageChange={(e: _object) => {
            setFilters({ ...filters, page: e.selected + 1 })
          }}
        />
      )}
      <AddNewCustomerModal />
    </>
  )
}
export default NewCustomers
